import {CdkDragDrop, copyArrayItem, moveItemInArray} from '@angular/cdk/drag-drop';
import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {Observable, ReplaySubject, Subject} from 'rxjs';
import {map} from 'rxjs/operators';
import {GlobalService} from '../../../../../../../global/global.service';

export interface ICardColumn {
    label: string,
    dataFieldContact: string,
    column: string,
    icon?: string,
    bootstrapIcon?: string,
    is_required: boolean,
}

export interface ICardsGroupedBy {
    [person: string]: ICardColumn
}
export interface IMatchRowItem{
    title: string,
    value: string
}

export interface IUploadMapping{
    label: string,
    is_empty: 1 | 0,
    column?: string
    icon?:string
    bootstrapIcon?:string
}

@Component({
    selector: 'app-match-columns-step',
    templateUrl: './match-columns-step.component.html',
    styleUrls: ['./match-columns-step.component.scss']
})
export class MatchColumnsStepComponent implements OnInit, OnDestroy {

    private _cardColumns: ICardColumn[] = [];
    private _rowItems:IMatchRowItem[] = [];
    @Input({required: true}) public defaultFields: IUploadMapping[] = [];

    @Input({required: true}) first_line_titles: 0 | 1;
    @Input({required: true}) set rowItems (rowItems: IMatchRowItem[]){
        this._rowItems = [...rowItems];
        this.defaultFields = this.setupDefaultFields([...rowItems],  this.defaultFields );
    }
    get rowItems(): IMatchRowItem[]{
        return this._rowItems;
    }

    @Input({required: true}) set cardColumns(cardColumns: ICardColumn[]) {
        this._cardColumns = [...cardColumns];
        this._cardColumn$.next([...cardColumns]);
    }
    @Input() loading: boolean = false;


    @Output() mappingChange: EventEmitter<IUploadMapping[]> = new EventEmitter<IUploadMapping[]>();
    @Output() first_line_titlesChange: EventEmitter<0 | 1> = new EventEmitter() ;

    get cardColumns(): ICardColumn[]{
        return this._cardColumns;
    }

    onFirst_line_titlesChange(event){
        this.first_line_titlesChange.next(event? 1:0);
    }

    private _cardColumn$: ReplaySubject<ICardColumn[]> = new ReplaySubject(1);
    private _untilDestroy$: Subject<void> = new ReplaySubject();

    public activeTabIndex: number = 0;
    public searchString: string = "";
    public cardsGroupedBy$: Observable<ICardsGroupedBy> = this._cardColumn$.pipe(map(x => this.groupBy(x, 'dataFieldContact')));
    hasRequiredFields$: Observable<boolean> = this._cardColumn$.pipe(map(x=>x.some(y=>y.is_required === true)));

    constructor(private globalService: GlobalService, private transloco: TranslocoService) {
    }

    ngOnDestroy(): void {
        this._untilDestroy$.next();
        this._untilDestroy$.complete();
    }

    ngOnInit(): void {
        this._cardColumn$.next(this.cardColumns);
    }


    addItemInSource(event:CdkDragDrop<string[]>) {
        const target = (<HTMLElement>event?.event?.target);
        const fieldContainer = target?.closest('.data-fields-container');
        if(fieldContainer){
            const index = fieldContainer?.getAttribute('index');
            this.defaultFields[index] = {...event.item.data, ...{is_empty: 0}};
        }
    }

    drop(event: CdkDragDrop<string[]>) {
        if (event.previousContainer !== event.container) {
            copyArrayItem(
                event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex
            );
        } else {
            moveItemInArray(
                event.container.data,
                event.previousIndex,
                event.currentIndex
            );
            
            const alreadyExist = this.defaultFields.find((x) => x.label == event.item?.data?.label);
            if (!alreadyExist) {
                this.addItemInSource({...event});
                this.filterAlreadyMappedCards();

            } else {
                this.globalService.toastrWarning(this.transloco.translate('Mapping exists notification (match column steps) - already exist', {name:event.item.data.label}));
            }
        }

        this.mappingChange.next([...this.defaultFields])
    }

    removeField(index: number) {
        this.defaultFields[index] = {
            label: this.transloco.translate('Empty mapping placeholder (match column steps) - Drag and Drop field here'),
            is_empty: 1
        };
        this.filterAlreadyMappedCards();
    }


    onSearchStringChange(search: string) {
        this._cardColumn$.next(
            this.cardColumns.filter(x => search?.trim().length > 0 ? x.label?.toLowerCase().includes(search.toLowerCase()) : true)
        );
    }

    private groupBy(xs, key) {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    }

    private setupDefaultFields(cardColumns: IMatchRowItem[], existingMappings: IUploadMapping[]): {label:string, is_empty: 1 | 0, column: string} [] {
       if(!existingMappings || existingMappings.length ===0) {
           return cardColumns.map(() => {
               return ({
                   is_empty: 1,
                   label: this.transloco.translate('Empty mapping placeholder (match column steps) - Drag and Drop field here'),
                   column: null
               } as { label: string, is_empty: 1 | 0, column: string })
           });
       }else{
           return  existingMappings  as  {label:string, is_empty: 1 | 0, column: string}[];
       }
    }

    private filterAlreadyMappedCards(): void {
        this._cardColumn$.next(this.cardColumns.filter(x => this.defaultFields.some(y => y.column === x.column) == false));
    }
}
